import { Table } from 'common/components/Table/Table'
import styles from './notes.module.scss'
import { useAppSelector } from 'common/hooks/redux'
import { drawingElementHasNoteContent } from 'features/Procedure/utils/drawingDescription.utils'
import { procedureNotesTableColumns } from './columns'

export const ProcedureNotesTable = ({ isLoading }: { isLoading: boolean }) => {
  const drawingElements = useAppSelector((state) => state.procedureReducer.drawingElements)
  const selectedProcedureId = useAppSelector(
    (state) => state.procedureReducer.selectedProcedure?.id,
  )
  const dataSource = drawingElements.filter(
    (el) => el.procedureId === selectedProcedureId && drawingElementHasNoteContent(el),
  )

  if (!dataSource.length) return null
  return (
    <div className={styles.container}>
      <span className={styles.title}>Notes</span>
      <Table
        itemKey='id'
        haveActions={false}
        dataSource={dataSource}
        columns={procedureNotesTableColumns}
        isLoading={isLoading}
      />
    </div>
  )
}
